// removed by extract-text-webpack-plugin
module.exports = {"SliderPointerDragFix":"AboutUsPanel-SliderPointerDragFix","StudioSlider":"AboutUsPanel-StudioSlider","TeamSlider":"AboutUsPanel-TeamSlider","DarkNavLink":"AboutUsPanel-DarkNavLink","LandTitleAck":"AboutUsPanel-LandTitleAck"};


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/theme/AboutUs/components/AboutUsPanel.less
// module id = 112
// module chunks = 0